import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./assets/css/resets.css";
import "./assets/css/stylegide.css";
import "./assets/css/common.css";
import Home from "./pages/Home";
import WithDrawalPage from "./pages/WithDrawalPage";
import Header from "./components/Navigation";
import TermsList from "./pages/terms/TermsList";
import TermsDetail from "./pages/terms/TermsDetail";
import FaqList from "./pages/faq/FaqList";
import FaqDetail from "./pages/faq/FaqDetail";
import FaqImportDetail from "./pages/faq/FaqImportDetail";
import QnaList from "./pages/qna/QnaList";
import QnaWrite from "./pages/qna/QnaWrite";
import KakaoApi from "./pages/KakaoApi";
import Modal from "./components/Modal";
import Loading from "./components/Loading";
import NoticeList from "./pages/notice/NoiticeList";
import NoticeDetail from "./pages/notice/NoticeDetail";
import NotFound from "./pages/NotFound";

const CautionInformationPage = React.lazy(() =>
  import("./pages/self-return/CautionInformationPage")
);

function App(props) {
  const [pageName, setPageName] = useState("");
  const [headerUi, setHeaderUi] = useState({});
  const [commonError, setCommonError] = useState(false);
  const [isLoading, setIsLoading] = useState(false); //loading view
  const [userIdError, setUserIdError] = useState(false);

  const onPageName = (page) => {
    setPageName(page);
  };
  const onHeaderUi = (ui) => {
    setHeaderUi(ui);
  };

  const onCommonError = (error) => {
    setCommonError(error);
  };
  const onUserIdError = (error) => {
    setUserIdError(error);
  };
  const onIsLoading = (load) => {
    setIsLoading(load);
  };

  useEffect(() => {
    if (isLoading === true || commonError === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isLoading, commonError]);

  // useEffect(() => {
  //     // REACT_APP_MODE가 prd가 아닌 경우에만 Eruda를 로드합니다.
  //     if (process.env.REACT_APP_MODE !== 'prd') {
  //         // Eruda 로드 스크립트 생성
  //         const erudaScript = document.createElement('script');
  //         erudaScript.src = "https://cdn.jsdelivr.net/npm/eruda";
  //         erudaScript.onload = () => {
  //             // Eruda 초기화
  //             window.eruda.init();
  //         };
  //         document.body.appendChild(erudaScript);
  //     }
  // }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header
          pageName={pageName}
          headerUi={headerUi}
          onError={onCommonError}
        />
        <Routes>
          <Route
            path="/pageList"
            element={
              <Home
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/terms"
            element={
              <TermsList
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/terms/:id"
            element={
              <TermsDetail
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/drawal"
            element={
              <WithDrawalPage
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
                // userId={userId}
              />
            }
          />
          <Route
            path="/faq"
            element={
              <FaqList
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/faq/:id"
            element={
              <FaqDetail
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/faqimport/:id"
            element={
              <FaqImportDetail
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/qna"
            element={
              <QnaList
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onUserIdError}
                onIsLoading={onIsLoading}
                // userId={userId}
              />
            }
          />
          <Route
            path="/qna/write"
            element={
              <QnaWrite
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
                // userId={userId}
                // appVer={appVer}
              />
            }
          />
          <Route
            path="/kakao"
            element={
              <KakaoApi
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/notice"
            element={
              <NoticeList
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/notice/:id"
            element={
              <NoticeDetail
                onPageName={onPageName}
                onHeaderUi={onHeaderUi}
                onError={onCommonError}
                onIsLoading={onIsLoading}
              />
            }
          />
          <Route
            path="/self-return/caution-information"
            element={
              <Suspense fallback={<></>}>
                <CautionInformationPage
                  onPageName={onPageName}
                  onHeaderUi={onHeaderUi}
                  onError={onCommonError}
                  onIsLoading={onIsLoading}
                />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/**성공적으로 앱과 소통시 고쳐야될 부분 이부분에서도 back 시켜줘야함 */}
        {commonError && (
          <Modal
            closeModal={() => {
              setCommonError(false);
            }}
            navi={true}
          >
            <div className="common_error">
              <p>오류가 발생하였습니다.</p>
              <p>다시 시도하여 주십시오.</p>
            </div>
          </Modal>
        )}
        {userIdError && (
          <Modal
            closeModal={() => {
              setUserIdError(false);
            }}
            navi={true}
          >
            <div className="common_error">
              <p>네트워크가 불안정합니다.</p>
              <p>다시 시도하여 주십시오.</p>
            </div>
          </Modal>
        )}
        {isLoading && <Loading />}
      </BrowserRouter>
    </div>
  );
}

export default App;
